var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('div',{ref:"container",staticStyle:{"height":"100%"}}),(_vm.infoMessage)?_c('elastic-dialog',{attrs:{"header":_vm.infoTitle,"hideCancel":"true","applyBtnName":"OK"},on:{"apply":function (){ return this$1.infoMessage=''; }}},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.infoMessage)}})])],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }